/** @jsxImportSource @emotion/react */
import { FC } from 'react';
import { Buttons, Dialogs } from '@zip/business-components';
import * as styles from './ActivationExitDialog.styles';

export interface ActivationExitDialogProps {
  open: boolean;
  onCancelExit: () => void;
  onConfirmExit: () => void;
  customOnExitDialogText?: string;
}

const ActivationExitDialog: FC<ActivationExitDialogProps> = ({
  open,
  onCancelExit,
  onConfirmExit,
  customOnExitDialogText,
}) => {
  const defaultOnExitDialogText =
    'You can continue your account setup at any time.';

  return (
    <Dialogs.Basic
      open={open}
      onClose={onCancelExit}
      showClose={false}
      css={styles.exitDialog}
      aria-labelledby="activation-exit-dialog-title"
      aria-describedby="activation-exit-dialog-description"
      actions={
        <>
          <Buttons.Primary
            css={styles.exitDialogPrimaryButton}
            onClick={onCancelExit}
          >
            Stay and continue
          </Buttons.Primary>
          <Buttons.Text onClick={onConfirmExit}>Back to dashboard</Buttons.Text>
        </>
      }
      spaceActions
    >
      <div css={styles.exitDialogContent}>
        <h2
          id="activation-exit-dialog-title"
          className="heading1"
          css={styles.exitDialogTitle}
        >
          Are you sure you want to exit?
        </h2>
        <p
          id="activation-exit-dialog-description"
          className="body2"
          css={styles.exitDialogDescription}
        >
          {customOnExitDialogText || defaultOnExitDialogText}
        </p>
      </div>
    </Dialogs.Basic>
  );
};

export default ActivationExitDialog;
